import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'

const KitchenSinkPage = ({ pageData }) => {
  return <WagtailBlocksSection blocks={pageData.content_blocks} />
}

export default KitchenSinkPage
